<template>
  <div class="signup">
    <div>
      <h2 class="text-center form__title mb-3">
        {{ $t('singup.createAccountChild') }}
      </h2>
      <el-form ref="form" :model="form" :rules="rules" label-width="140px" class="form">
        <el-form-item label="First name" prop="firstName">
          <el-input v-model="form.firstName"></el-input>
        </el-form-item>
        <el-form-item label="Last name" prop="lastName">
          <el-input v-model="form.lastName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="Tutor" prop="tutorId">
          <el-select
            v-model="form.tutorId"
            filterable
            remote
            reserve-keyword
            placeholder="Please enter a first name"
            :remote-method="fetchTutors"
            :loading="loading"
            popper-class="text-capitalize"
            class="w-100"
          >
            <el-option
              v-for="tutor in tutors"
              :key="tutor.id"
              :label="tutor.firstname + ' ' + tutor.lastname"
              :value="tutor.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="Access all content" prop="accessAllContent">
          <el-switch v-model="form.accessAllContent" active-text="All access" inactive-text="Restricted access">
          </el-switch>
        </el-form-item>
        <el-form-item label="Grade" prop="gradeId">
          <el-select v-model="form.gradeId" placeholder="Select" class="w-100">
            <el-option v-for="grade in grades" :key="grade.id" :label="grade.name" :value="grade.id"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="Username" prop="username">
          <el-input v-model="form.username"></el-input>
        </el-form-item>
        <el-form-item label="Password" prop="password">
          <el-input v-model="form.password" type="password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item label="Confirm" prop="checkPassword">
          <el-input v-model="form.checkPassword" type="password" autocomplete="off" show-password></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="submitForm('form')">Create</el-button>
          <el-button size="small" @click="resetForm('form')">Reset</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
// import moment from 'moment'
import { mapGetters } from 'vuex';

export default {
  name: 'Signup',
  data: function () {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password'));
      } else {
        if (this.form.checkPassword !== '') {
          this.$refs.form.validateField('checkPassword');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please input the password again'));
      } else if (value !== this.form.password) {
        callback(new Error("Two inputs don't match!"));
      } else {
        callback();
      }
    };
    var checkUsername = (rule, value, callback) => {
      if (value != '') {
        this.$httpMain
          .post(`find-username`, {
            username: this.form.username,
          })
          .then(res => {
            if (res.data === true) {
              callback(new Error('this username already exist'));
            } else {
              callback();
            }
          })
          .catch(err => {
            console.log(err);
          });
      }
    };
    return {
      grades: [],
      // tutors: [],
      loading: false,
      form: {
        firstName: '',
        lastName: '',
        username: '',
        password: '',
        checkPassword: '',
        gradeId: null,
        tutorId: null,
        accessAllContent: true,
      },
      rules: {
        firstName: [
          { required: true, message: 'Please input first name', trigger: 'blur' },
          { min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur' },
        ],
        lastName: [
          { required: true, message: 'Please input last name', trigger: 'blur' },
          { min: 3, max: 20, message: 'Length should be 3 to 20', trigger: 'blur' },
        ],
        username: [
          { validator: checkUsername, trigger: 'blur' },
          { required: true, message: 'Please input username', trigger: 'blur' },
          { min: 3, max: 25, message: 'Length should be 3 to 25', trigger: 'blur' },
        ],
        password: [
          { validator: validatePass, trigger: 'blur' },
          { required: true, message: 'Please input password', trigger: 'blur' },
          { min: 3, max: 25, message: 'Length should be 3 to 25', trigger: 'blur' },
        ],
        checkPassword: [{ validator: validatePass2, trigger: 'blur' }],
        gradeId: [{ required: true, message: 'Please input grade', trigger: 'blur' }],
        tutorId: [{ required: true, message: 'Please input tutor', trigger: 'blur' }],
      },
    };
  },
  computed: {
    ...mapGetters({
      authenticatedUser: 'auth/authenticatedUser',
    }),
  },
  created() {
    this.fetchGrades();
  },
  methods: {
    fetchGrades() {
      this.$httpMain
        .get('grades')
        .then(res => {
          this.grades = res.data;
        })
        .catch(() => {
          this.grades = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // fetchTutors(query) {
    //   if (query !== '') {
    //     this.loading = true;
    //     let filtersJSON = JSON.stringify({
    //       query: query,
    //     });
    //     this.$httpMain
    //       .get(`tutors?term=search&filters=${filtersJSON}`)
    //       .then(res => {
    //         this.tutors = res.data;
    //       })
    //       .catch(() => {
    //         this.tutors = [];
    //       })
    //       .finally(() => {
    //         this.loading = false;
    //       });
    //   } else {
    //     this.tutors = [];
    //   }
    // },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.$httpMain
            .post(`signup/student`, {
              firstname: this.form.firstName,
              lastname: this.form.lastName,
              username: this.form.username,
              password: this.form.password,
              tutor_id: this.authenticatedUser.id,
              rol_id: 1,
              language: 'en',
              grade_id: this.form.gradeId,
              access_all_content: this.form.accessAllContent,
            })
            .then(() => {
              this.$notify({
                title: 'Success',
                message: 'Student successfully created',
                type: 'success',
                position: 'bottom-right',
              });
              this.$refs[formName].resetFields();
            })
            .catch(err => {
              this.$notify({
                title: 'Error',
                message: err.message ? 'You have reached the limit of users for this tutor ' : err.message,
                type: 'error',
                position: 'bottom-right',
              });
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.signup
  display: flex
  justify-content: center
  align-items: center
  // min-height: calc(100vh - 35px)
  +forDesktop
    margin-top: 5em
    min-height: unset
.form
  background-color: #fff
  border-radius: 10px
  padding: 1.8rem 1.2rem
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.5)
  width: 600px
  +element('title')
    font-size: 26px
</style>
